import type { AiProviderConnectionTestPayload } from '@Application/Ai/AiConfiguration/Providers/Actions/aiProviderConnectionTested';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Carries a provider connection test result: `models` lists what the provider exposes, whether or not
 * a specific model was tested — distinct from `ModelConnectionTestView`, which carries a single
 * `usage` instead of a listing.
 */
class ProviderConnectionTestView {
	readonly succeeded: boolean;
	readonly message: string;
	readonly testedAt: string;
	readonly models: readonly string[];

	constructor(payload: AiProviderConnectionTestPayload) {
		this.succeeded = payload.succeeded;
		this.message = payload.message;
		this.testedAt = payload.testedAt;
		this.models = payload.models;

		Object.freeze(this);
	}
}

export default ProviderConnectionTestView;
